import { Suspense } from "react";
import { useLocation, useOutlet } from "react-router-dom";
import subRoutes from "routes/public.route";
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import Menu from "components/custom/menu";
import Loader from "components/custom/loader";

export default function PublicPages() {

    const location = useLocation()
    const currentOutlet = useOutlet()
    const { nodeRef }: any =
        subRoutes.find((route) => route.path === location.pathname) ?? {}

    return (
        <Suspense fallback={<Loader />}>
            <Menu />
            <SwitchTransition>
                <CSSTransition
                    key={location.pathname}
                    nodeRef={nodeRef}
                    timeout={300}
                    classNames="page"
                    unmountOnExit
                >
                    {() => (
                        <div ref={nodeRef} className="page">
                            {currentOutlet}

                        </div>
                    )}
                </CSSTransition>
            </SwitchTransition>
        </Suspense>
    );
}